import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import * as serviceworkerregistration from './serviceWorkerRegistration'
import { AppProvider } from './context'

// منع الترجمة التلقائية من المتصفحات
document.addEventListener('DOMContentLoaded', function() {
  // إضافة خاصية translate="no" لجميع العناصر
  const allElements = document.querySelectorAll('*');
  allElements.forEach(element => {
    element.setAttribute('translate', 'no');
  });
  
  // منع الترجمة في Google Chrome
  if (window.google && window.google.translate) {
    window.google.translate.TranslateElement.InlineLayout.SIMPLE = function() {};
  }
  
  // إضافة CSS لمنع الترجمة
  const style = document.createElement('style');
  style.textContent = `
    * {
      translate: no !important;
      -webkit-translate: no !important;
      -moz-translate: no !important;
      -ms-translate: no !important;
    }
    html, body {
      translate: no !important;
    }
  `;
  document.head.appendChild(style);
});

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <AppProvider>
    <App />
  </AppProvider>
)
// تسجيل service worker
serviceworkerregistration.register({
  onUpdate: registration => {
    const waitingServiceWorker = registration.waiting;
    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", event => {
        if (event.target.state === "activated") {
          window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  }
});

export default root
